import { useEffect, useState } from 'react'

export function useElapsedTime(startTime: string) {
  const [elapsed, setElapsed] = useState('')

  useEffect(() => {
    const updateElapsed = () => {
      const start = new Date(startTime)
      const now = new Date()
      const diffMs = now.getTime() - start.getTime()
      const diffMins = Math.floor(diffMs / 60000)

      if (diffMins < 1) {
        setElapsed('Adesso')
      } else if (diffMins < 60) {
        setElapsed(`${diffMins}m`)
      } else {
        const hours = Math.floor(diffMins / 60)
        const mins = diffMins % 60
        setElapsed(`${hours}h ${mins}m`)
      }
    }

    updateElapsed()
    const interval = setInterval(updateElapsed, 30000) // Update every 30 seconds

    return () => clearInterval(interval)
  }, [startTime])

  return elapsed
}
